import {
  CardContent,
  Grid,
  WithStyles,
  withStyles,
  Button,
  IconButton,
  Card,
} from "@material-ui/core";
import React, { Component, ReactNode } from "react";
import { connect } from "react-redux";
import { DialogLargeStyle } from "../styles/DialogLargeStyle";
import { MyPATDialog } from "../../common";
import DialogHeader from "./DialogHeader";
import CloseIcon from "@material-ui/icons/Close";
import DialogFooter from "./DialogFooter";
import DialogTopNav from "./DialogTopNav";
import { TopNav } from "../types/ContentRequest";
import MyPATToaster from "../../../../src/components/common/MyPATToaster";

interface data {
  icon?: string;
  label?: string;
  subLabel?: string;
  color?: string;
  showErrorToast: any;
}

interface DialogLargeProps extends WithStyles<typeof DialogLargeStyle> {
  headerCTAName?: string;
  htmlElements: ReactNode;
  headerTitle: string;
  isFooter: boolean;
  topNavValue?: TopNav;
  showTopNavContent?: boolean;
  onJobDone?: () => void;
  isJobDoneDisabled?: boolean;
  isSaveHidden?: boolean;
  isEditHidden?: boolean;
  onSave?: () => void;
  onEdit?: () => void;
  footerCTAName?: string;
  isShowHeader?: boolean;
  dialogCloseHandler?: () => void;
}

class DialogLarge extends Component<DialogLargeProps> {
  constructor(props: DialogLargeProps) {
    super(props);
  }

  render() {
    const {
      classes,
      htmlElements,
      isFooter,
      headerTitle,
      topNavValue,
      showTopNavContent = true,
      onSave,
      onJobDone,
      footerCTAName = "Job Done",
      headerCTAName = "Save",
      onEdit,
      isShowHeader = true,
      dialogCloseHandler,
    } = this.props;
    return (
      <>
        <Card classes={{ root: classes.cardContainer }} elevation={0}>
          {isShowHeader && (
            <DialogHeader
              dialogCloseHandler={dialogCloseHandler}
              urlName="/contentRequest"
              onSave={onSave}
              onEdit={onEdit}
              onJobDone={onJobDone}
              iconNode={
                <>
                  <IconButton aria-label="settings">
                    <CloseIcon />
                  </IconButton>
                </>
              }
              headerTitle={headerTitle}
              isSaveHidden={this.props.isSaveHidden}
              isEditHidden={this.props.isEditHidden}
              headerCTAName={headerCTAName}
            />
          )}
          <CardContent
            classes={{
              root: [
                classes.cardContent,
                isFooter && classes.cardContentHeight,
              ].join(" "),
            }}
          >
            {showTopNavContent && <DialogTopNav topNavValue={topNavValue} />}
            {this.props.children}
          </CardContent>
          {isFooter && (
            <DialogFooter
              leftHTMLElement={
                <Button
                variant="contained"
                color="primary"
                // style={{alignItems: "flex-end"}}
                onClick={this.props.onJobDone}
                disabled={this.props.isJobDoneDisabled}
              >
                {footerCTAName}
              </Button>
              }
              htmlElements={
                <>
                    {htmlElements }
                </>
              }
            />
          )}
        </Card>
      </>
    );
  }
}
// @ts-ignore
export default connect()(withStyles(DialogLargeStyle)(DialogLarge));
